import { KeyboardEvent, ReactNode } from 'react'
import styles from './CommandPaletteInput.module.css'

interface CommandPaletteInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  shortcut?: ReactNode
  autoFocus?: boolean
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void
}

const SearchIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
)

export function CommandPaletteInput({
  value,
  onChange,
  placeholder = 'Search...',
  shortcut,
  autoFocus,
  onKeyDown,
}: CommandPaletteInputProps) {
  return (
    <div className={styles.CommandPaletteInput}>
      <span className={styles.CommandPaletteInput__icon}>
        <SearchIcon />
      </span>
      <input
        className={styles.CommandPaletteInput__input}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        aria-label={placeholder}
      />
      {shortcut && (
        <span className={styles.CommandPaletteInput__shortcut}>
          {shortcut}
        </span>
      )}
    </div>
  )
}
